export const SET_HEALTH_PLANS = 'setHealthPlans'
